import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconIconShape32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconIconShape32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 7h14q.27.001.518.068l-3.326 3.326A6.97 6.97 0 0 0 16 9a6.97 6.97 0 0 0-4.192 1.394L8.482 7.068Q8.73 7 9 7M7.068 8.482A2 2 0 0 0 7 9v14q.001.27.068.518l3.326-3.326A6.97 6.97 0 0 1 9 16a6.97 6.97 0 0 1 1.394-4.192zm4.76 4.76A5 5 0 0 0 11 16c0 1.02.305 1.967.828 2.757L14.586 16zM16 17.415l-2.757 2.758c.79.523 1.738.828 2.757.828s1.967-.305 2.757-.828zm4.172 1.343L17.414 16l2.758-2.757c.523.79.828 1.738.828 2.757s-.305 1.967-.828 2.757m.02 2.85A6.97 6.97 0 0 1 16 23a6.97 6.97 0 0 1-4.192-1.394l-3.326 3.326Q8.73 25 9 25h14q.27-.001.518-.068zm4.74 1.911-3.326-3.326A6.97 6.97 0 0 0 23 16a6.97 6.97 0 0 0-1.394-4.192l3.326-3.326Q25 8.73 25 9v14q-.001.27-.068.518M16 14.586l-2.757-2.758A5 5 0 0 1 16 11c1.02 0 1.967.305 2.757.828zM5 9a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconIconShape32);
